import React from 'react';
import { FaithlifeButton, TwitterButton, FacebookButton } from 'react-social';
import { CopyToClipboardButton } from '../copy-to-clipboard-button';
import baseUrls from '../../data/baseUrls';
import { facebookAppId } from '../../data/sharing';
import './index.less';

interface IShareOverlayProps {
	active?: boolean;
	hideShare: () => void;
	itemId: string;
}

export class ShareOverlay extends React.Component<IShareOverlayProps> {
	_handleCloseButton: React.EventHandler<React.SyntheticEvent> = () => {
		this.props.hideShare();
	};

	_highlight(e) {
		e.target.select();
	}

	render() {
		const { itemId, active } = this.props;
		const shareUrl = `${baseUrls.faithlifeTv}/media/${itemId}`;
		const container = active ? 'container-active' : 'container-inactive';

		return (
			<div className={`share-overlay ${container}`}>
				{/* TODO: Fix this the next time the file is edited. */}
				{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
				<div className="close-button" onClick={this._handleCloseButton}>
					&#x2A09;
				</div>
				<div className="share">
					<div className="share-text">
						<h3>Share</h3>
						<input type="text" value={shareUrl} onFocus={this._highlight} readOnly />
						<CopyToClipboardButton textToCopy={shareUrl} />
					</div>
					<div>
						<FaithlifeButton className="share-button" url={shareUrl}>
							<div className="faithlife-image" />
							<div className="info">Faithlife</div>
						</FaithlifeButton>
						<TwitterButton className="share-button" url={shareUrl}>
							<div className="twitter-image" />
							<div className="info">Twitter</div>
						</TwitterButton>
						<FacebookButton className="share-button" url={shareUrl} appId={facebookAppId}>
							<div className="facebook-image" />
							<div className="info">Facebook</div>
						</FacebookButton>
					</div>
				</div>
			</div>
		);
	}
}
